import React, { useState } from 'react';
import { Box, Text, Button, Input, VStack, HStack } from '@chakra-ui/react';
import { MIN_PASSWORD_LENGTH } from '../constants';

interface PasswordStepProps {
  password: string;
  setPassword: (value: string) => void;
  confirmPassword: string;
  setConfirmPassword: (value: string) => void;
  isFormValid: boolean;
  isLoading: boolean;
  onNext: () => void;
  buttonText?: string;
  topPosition?: number;
  showButton?: boolean;
}

const PasswordStep: React.FC<PasswordStepProps> = ({
  password,
  setPassword,
  confirmPassword,
  setConfirmPassword,
  isFormValid,
  isLoading,
  onNext,
  buttonText = "Next",
  topPosition = 200,
  showButton = true,
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  // Password validation functions
  const validatePassword = (password: string) => {
    return {
      hasSpecialChar: /[!@#$%^&*(),.?":{}|<>]/.test(password),
      hasMinLength: password.length >= MIN_PASSWORD_LENGTH,
      hasUppercase: /[A-Z]/.test(password),
      hasLowercase: /[a-z]/.test(password),
      passwordsMatch: password === confirmPassword && password.length > 0
    };
  };

  const passwordValidation = validatePassword(password);

  return (
    <>
      {/* Password Form */}
      <Box
        position="absolute"
        top={`${topPosition}px`}
        left="22px"
        width="332px"
        height="200px"
        className="form-container"
        // backgroundColor="#120F1B"
        // borderRadius="28px"
        // padding="22px 18px"
      >
        <Text
          className="subtitle-text"
          // fontFamily="Urbanist, sans-serif"
          // fontWeight="500"
          // fontSize="16px"
          // lineHeight="1"
          // color="#FFFFFF"
          marginBottom="10px"
        >
          Set up your password
        </Text>

        <VStack spacing="16px" align="stretch">
          {/* Password Field */}
          <Box position="relative">
            <Input
              type={showPassword ? "text" : "password"}
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="input-in-form"
              id="password"
              name="password"
              // backgroundColor="transparent"
              // color="#FFFFFF"
              // border="none"
              // borderBottom="1px solid #595C5D"
              // borderRadius="0"
              // padding="0 40px 15px 0"
              // fontFamily="Urbanist, sans-serif"
              // fontWeight="500"
              // fontSize="14px"
              // _placeholder={{
              //   color: "#FFFFFF",
              //   opacity: 0.7
              // }}
              // _focus={{
              //   boxShadow: "none",
              //   borderBottom: "1px solid #C6D959"
              // }}
            />
            <Box
              position="absolute"
              right="0"
              top="0"
              cursor="pointer"
              onClick={() => setShowPassword(!showPassword)}
              padding="10px"
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                {showPassword ? (
                  // Eye crossed icon
                  <>
                    <path d="M22 12C22 12 19 18 12 18C5 18 2 12 2 12C2 12 5 6 12 6C19 6 22 12 22 12Z" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round"/>
                    <circle cx="12" cy="12" r="3" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round"/>
                    <path d="M3 21L20 4" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round"/>
                  </>
                ) : (
                  // Eye icon
                  <>
                    <path d="M22 12C22 12 19 18 12 18C5 18 2 12 2 12C2 12 5 6 12 6C19 6 22 12 22 12Z" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round"/>
                    <circle cx="12" cy="12" r="3" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round"/>
                  </>
                )}
              </svg>
            </Box>
          </Box>

          {/* Confirm Password Field */}
          <Box position="relative">
            <Input
              type={showConfirmPassword ? "text" : "password"}
              placeholder="Confirm password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              className="input-in-form"
              id="confirmPassword"
              name="confirmPassword"
              // backgroundColor="transparent"
              // color="#FFFFFF"
              // border="none"
              // borderBottom="1px solid #595C5D"
              // borderRadius="0"
              // padding="0 40px 15px 0"
              // fontFamily="Urbanist, sans-serif"
              // fontWeight="500"
              // fontSize="14px"
              // _placeholder={{
              //   color: "#FFFFFF",
              //   opacity: 0.7
              // }}
              // _focus={{
              //   boxShadow: "none",
              //   borderBottom: "1px solid #C6D959"
              // }}
            />
            <Box
              position="absolute"
              right="0"
              top="0"
              cursor="pointer"
              onClick={() => setShowConfirmPassword(!showConfirmPassword)}
              padding="10px"
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                {showConfirmPassword ? (
                  // Eye crossed icon
                  <>
                    <path d="M22 12C22 12 19 18 12 18C5 18 2 12 2 12C2 12 5 6 12 6C19 6 22 12 22 12Z" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round"/>
                    <circle cx="12" cy="12" r="3" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round"/>
                    <path d="M3 21L20 4" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round"/>
                  </>
                ) : (
                  // Eye icon
                  <>
                    <path d="M22 12C22 12 19 18 12 18C5 18 2 12 2 12C2 12 5 6 12 6C19 6 22 12 22 12Z" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round"/>
                    <circle cx="12" cy="12" r="3" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round"/>
                  </>
                )}
              </svg>
            </Box>
          </Box>
        </VStack>
      </Box>

      {/* Password Requirements */}
      <Text
        position="absolute"
        top={`${topPosition + 220}px`}
        left="22px"
        width="294px"
        className="subtitle-text"
        // fontFamily="Urbanist, sans-serif"
        // fontWeight="500"
        // fontSize="16px"
        // lineHeight="1"
        // color="#FFFFFF"
        //marginBottom="10px"
      >
        Make sure your password contains below:
      </Text>

      {/* Validation Requirements */}
      <VStack spacing="16px" position="absolute" top={`${topPosition + 282}px`} left="23px" align="flex-start">
        {/* Special Character */}
        <HStack spacing="10px" alignItems="center">
          <Box width="13px" height="13px">
            {passwordValidation.hasSpecialChar ? (
              <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
                <path d="M11 3.5L4.5 10L2 7.5" stroke="#C6D959" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            ) : (
              <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
                <circle cx="6.5" cy="6.5" r="6" stroke="#90909A" strokeWidth="1.5"/>
              </svg>
            )}
          </Box>
          <Text
            fontFamily="Urbanist, sans-serif"
            fontWeight="500"
            fontSize="16px"
            lineHeight="1"
            color="#90909A"
          >
            Special character
          </Text>
        </HStack>

        {/* Minimum 8 Letters */}
        <HStack spacing="10px" alignItems="center">
          <Box width="13px" height="13px">
            {passwordValidation.hasMinLength ? (
              <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
                <path d="M11 3.5L4.5 10L2 7.5" stroke="#C6D959" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            ) : (
              <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
                <circle cx="6.5" cy="6.5" r="6" stroke="#90909A" strokeWidth="1.5"/>
              </svg>
            )}
          </Box>
          <Text
            fontFamily="Urbanist, sans-serif"
            fontWeight="500"
            fontSize="16px"
            lineHeight="1"
            color="#90909A"
          >
            Minimum {MIN_PASSWORD_LENGTH} letters
          </Text>
        </HStack>

        {/* Uppercase Character */}
        <HStack spacing="10px" alignItems="center">
          <Box width="13px" height="13px">
            {passwordValidation.hasUppercase ? (
              <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
                <path d="M11 3.5L4.5 10L2 7.5" stroke="#C6D959" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            ) : (
              <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
                <circle cx="6.5" cy="6.5" r="6" stroke="#90909A" strokeWidth="1.5"/>
              </svg>
            )}
          </Box>
          <Text
            fontFamily="Urbanist, sans-serif"
            fontWeight="500"
            fontSize="16px"
            lineHeight="1"
            color="#90909A"
          >
            Uppercase character
          </Text>
        </HStack>

        {/* Lowercase Character */}
        <HStack spacing="10px" alignItems="center">
          <Box width="13px" height="13px">
            {passwordValidation.hasLowercase ? (
              <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
                <path d="M11 3.5L4.5 10L2 7.5" stroke="#C6D959" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            ) : (
              <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
                <circle cx="6.5" cy="6.5" r="6" stroke="#90909A" strokeWidth="1.5"/>
              </svg>
            )}
          </Box>
          <Text
            fontFamily="Urbanist, sans-serif"
            fontWeight="500"
            fontSize="16px"
            lineHeight="1"
            color="#90909A"
          >
            Lowercase character
          </Text>
        </HStack>

        {/* Password Matched */}
        <HStack spacing="10px" alignItems="center">
          <Box width="13px" height="13px">
            {passwordValidation.passwordsMatch ? (
              <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
                <path d="M11 3.5L4.5 10L2 7.5" stroke="#C6D959" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            ) : (
              <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
                <circle cx="6.5" cy="6.5" r="6" stroke="#90909A" strokeWidth="1.5"/>
              </svg>
            )}
          </Box>
          <Text
            fontFamily="Urbanist, sans-serif"
            fontWeight="500"
            fontSize="16px"
            lineHeight="1"
            color="#90909A"
          >
            Password Matched
          </Text>
        </HStack>
      </VStack>

      {/* Next Button */}
      {showButton && (
        <Box
          position="absolute"
          bottom="30px"
          left="22px"
          width="332px"
          height="52px"
        >
          <Button
            width="100%"
            height="52px"
            backgroundColor={isFormValid ? "#C6D959" : "#23202B"}
            color={isFormValid ? "#0C1301" : "#979C9E"}
            borderRadius="48px"
            fontFamily="Urbanist, sans-serif"
            fontWeight="700"
            fontSize="16px"
            onClick={onNext}
            isLoading={isLoading}
            loadingText="Loading..."
            isDisabled={!isFormValid}
            _hover={isFormValid ? {
              backgroundColor: "#b8cc4a",
              transform: "translateY(-1px)",
              boxShadow: "0 4px 4px rgba(0, 0, 0, 0.25)"
            } : {}}
            _disabled={{
              backgroundColor: "#23202B",
              color: "#979C9E",
              cursor: "not-allowed"
            }}
          >
            {buttonText}
          </Button>
        </Box>
      )}
    </>
  );
};

export default PasswordStep;
